import { createSlice, current } from "@reduxjs/toolkit";

export const creditCards = createSlice({
  name: "creditCards",
  initialState: {
    list: null,
  },
  reducers: {
    setcreditCardsList: (state, action) => {
      if (action.payload) state.list = action.payload
    },
    updateCreditCards: (state, action) => {
      if (action.payload) {
        // Assuming action.payload is an array of credit cards
        if (state.list === null) {
          state.list = action.payload;
          return;
        }

        state.list = state.list.map((card) => {
          const updatedCard = action.payload.find((newCard) => newCard.id === card.id);
          return updatedCard ? updatedCard : card;
        });
        // add new cards that do not exist in the current state
        action.payload.forEach((newCard) => {
          if (!state.list.some(card => card.id === newCard.id)) {
            state.list.push(newCard);
          }
        });
      }
    }
  }
});

export default creditCards.reducer

export const selectAllEmails = state => state.creditCards.list
export const allActiveNotDeletedCcForUser = (state, userId) =>
  state.creditCards && state.creditCards.list
    ? state.creditCards.list.filter(
      card =>
        parseInt(card.assignedUserID) === parseInt(userId) &&
        card.isActive === true &&
        card.isDeleted === false
    )
    : [];


export const { setcreditCardsList, updateCreditCards } = creditCards.actions

//CREDIT CARD EXAMPLE:
/*
{
  id: 5,
  parentCardID: null,
  assignedUserID: 1,
  cardTypeID: 1,
  cardBrandID: 7,
  nameOnCard: '',
  creditCard_IV: '',
  address: 'Fake Street 1234',
  city: 'Miami',
  state: 'FL',
  zip: '33177',
  cardNumber: '',
  expirMonth: '',
  expirYear: '',
  cvvCode: '',
  cvvCode_IV: '',
  last4Digits: '',
  createdBy: 1,
  createdOn: '2022-02-02T15:15:44.86',
  modifiedBy: 3,
  modifiedOn: '2022-06-27T15:50:39.72',
  isActive: true,
  isDeleted: false,
  assignedUser: {
    id: 1,
    firstName: '',
    lastName: '',
    email: '',
    passwordHash: '$2a$11$DBaImLcZd/Np4lxzT2RfEueOGY.flkyB2ffUoowlvAbdD1X1BNcCW',
    acceptTerms: true,
    screenName: '',
    address1: 'main adress streetArizona',
    address2: null,
    city: '',
    state: 'American Samoa',
    zip: '',
    mobilePhone: '',
    role: 'Admin',
    userTypeId: 1,
    status: 'Active',
    verificationToken: null,
    verified: '2021-09-17T15:29:57.845619',
    isVerified: true,
    resetToken: null,
    discordTag: '',
    paymentsEmail: null,
    resetTokenExpires: null,
    passwordReset: null,
    createdBy: null,
    modifiedBy: null,
    created: '2021-09-17T15:29:44.9847111',
    updated: '2023-06-26T13:21:02.8675454',
    lastSignIn: '2023-06-28T01:16:52.943',
    lastClaimDate: '2023-06-26T13:45:03.933',
    userDistribution: true,
    useSwarm: true,
    isDeleted: false,
    notes: 'test con nico'
  },
  parentCard: null,
  cardBrand: {
    id: 7,
    name: 'Chase',
    modifiedBy: null,
    modifiedOn: '2022-06-08T11:28:11.357'
  },
  cardType: {
    id: 1,
    name: 'Amex Starwood',
    modifiedBy: null,
    modifiedOn: '2022-06-24T16:23:54.337'
  }
}
*/
